import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function getUserSignature() {
  let res;

  try {
    res = await authFetch(`${BACKEND_URL}/user/signature`, {
      method: "GET",
    });
  } catch (error) {
    return {
      success: false,
      signatureImageUrl: "",
      ...normalizeApiMessageWithFallbackKey(
        { message: error?.message || "Network error occurred." },
        error?.message || "Network error occurred.",
        "api.common.networkError",
      ),
    };
  }

  let result = null;
  try {
    result = await res.json();
  } catch {
    result = null;
  }

  if (!result) {
    return {
      success: false,
      signatureImageUrl: "",
      ...normalizeApiMessageWithFallbackKey(
        { message: "Failed to parse server response." },
        "Failed to parse server response.",
        "api.common.serverError",
      ),
    };
  }

  if (!res.ok || result?.success !== true) {
    return {
      success: false,
      signatureImageUrl: "",
      ...normalizeApiMessageWithFallbackKey(
        result,
        "Failed to load user signature.",
        res.status === 404
          ? "api.auth.user.notFound"
          : res.status === 401
            ? "api.auth.token.invalid"
            : "api.common.serverError",
      ),
    };
  }

  return {
    success: true,
    signatureImageUrl: result?.signatureImageUrl || "",
    ...normalizeApiMessageWithFallbackKey(
      result,
      "User signature loaded successfully.",
      "api.user.signature.success",
    ),
  };
}
